var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChoiceBranch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15C18.2165 15 19 14.2165 19 13.25C19 12.2835 18.2165 11.5 17.25 11.5C16.2835 11.5 15.5 12.2835 15.5 13.25C15.5 14.2165 16.2835 15 17.25 15Z",
    stroke: "#98BDBD",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 8C11.2165 8 12 7.2165 12 6.25C12 5.2835 11.2165 4.5 10.25 4.5C9.2835 4.5 8.5 5.2835 8.5 6.25C8.5 7.2165 9.2835 8 10.25 8Z",
    stroke: "#98BDBD",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 8C10.25 9.39239 10.8031 10.7277 11.7877 11.7123C12.7723 12.6969 14.1076 13.25 15.5 13.25",
    stroke: "#98BDBD",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 15C2.2835 15 1.5 14.2165 1.5 13.25C1.5 12.2835 2.2835 11.5 3.25 11.5C4.2165 11.5 5 12.2835 5 13.25C5 14.2165 4.2165 15 3.25 15Z",
    stroke: "#98BDBD",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 8C10.25 9.39239 9.69688 10.7277 8.71231 11.7123C7.72774 12.6969 6.39239 13.25 5 13.25",
    stroke: "#98BDBD",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoiceBranch);
export default __webpack_public_path__ + "static/media/choice_branch.42cf609f19a336f7d8444283aa9abd96.svg";
export { ForwardRef as ReactComponent };